import {PolIcon} from "components/PolIcon/policon";
import React from 'react';
import {QUOTE} from "v4/data/entities";
import ListingExport from "v4/features/front/export/components/ListingExport/ListingExport";
import SearchLinkedEntitiesList from "v4/features/front/searchLinkedEntities/components/searchLinkedEntitiesList";
import {usePolTranslation} from "v4/hooks/usePolTranslation";

export default function QuotesListingTools({checkedRows}) {
    const {t} = usePolTranslation();
    const handleNoSelectedItems = (e) => (checkedRows?.length === 0) && e.stopPropagation();

    return (
        <>
            <ListingExport selectedItems={checkedRows} entity={QUOTE}/>
            <li className="listing-header__action dropdown"
                title={t('options')} onClickCapture={handleNoSelectedItems}>
                <PolIcon icon="actions" className="action__picto"/>
                <ul className="listing-header__action__dropdown">
                    <SearchLinkedEntitiesList entity={QUOTE} checkedRows={checkedRows}/>
                </ul>
            </li>
        </>
    )
}
